import { cookieNames } from '@elab/core/utils/constants';

import { deleteCookie, getCookie, setCookie } from './cookie';

export const isAuthorized = () => getCookie(cookieNames.tokenType) === 'user';

export const isAnonymous = () => !isAuthorized();

export const setRegisteredOnCheckout = isRegisteredOnCheckout => {
    if (isRegisteredOnCheckout) {
        // this cookie is used on server side for correct redirection logic
        setCookie(cookieNames.isCheckoutRegistration, true, false);
    } else {
        deleteCookie(cookieNames.isCheckoutRegistration);
    }
};

export const getRegisteredOnCheckout = () => getCookie(cookieNames.isCheckoutRegistration);

export default {
    isAnonymous,
    isAuthorized,
    setRegisteredOnCheckout,
    getRegisteredOnCheckout,
};
